// src/CustomHeader.ts
import { Quill } from 'react-quill';

const BlockEmbed = Quill.import('blots/block/embed');

class CustomHeader extends BlockEmbed {
  static blotName = 'customHeader';
  static tagName = 'h1';

  static create(value: any) {
    let node = super.create();
    node.setAttribute('id', value.replace(/\s+/g, '-').toLowerCase());
    node.innerHTML = value;
    return node;
  }

  static value(node: any) {
    return node.innerHTML;
  }
}

CustomHeader.blotName = 'customHeader';
CustomHeader.tagName = 'h1'; // 여기서 원하는 h 태그를 설정할 수 있습니다. 예: 'h2', 'h3', etc.

export default CustomHeader;
